import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

import { validateFolderDisplayName } from "../../utils/validateDisplayName";

type Props = {
  open: boolean;
  initialName: string;
  isSubmitting?: boolean;
  serverError?: string | null;
  onClose: () => void;
  onSubmit: (displayName: string) => void;
};

export function FolderRenameModal({
  open,
  initialName,
  isSubmitting = false,
  serverError = null,
  onClose,
  onSubmit,
}: Props) {
  const [value, setValue] = useState(initialName);
  const [clientError, setClientError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setValue(initialName);
    setClientError(null);
  }, [initialName, open]);

  const handleSubmit = () => {
    const validation = validateFolderDisplayName(value);
    if (!validation.ok) {
      setClientError(validation.message);
      return;
    }

    setClientError(null);
    onSubmit(validation.displayName);
  };

  const errorMessage = clientError ?? serverError;

  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Renomear pasta</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Nome da pasta"
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            if (clientError) setClientError(null);
          }}
          disabled={isSubmitting}
          error={!!errorMessage}
          helperText={errorMessage}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleSubmit();
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isSubmitting} sx={{ textTransform: "none" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isSubmitting}
          sx={{ textTransform: "none" }}
        >
          {isSubmitting ? "Salvando..." : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
